import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37cacab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper flex z-50 items-center border-b dark:border-dark-400" }
const _hoisted_2 = {
  id: "header",
  class: "flex h-full",
  style: {"width":"41%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-full" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-full" }, null, -1))
const _hoisted_5 = {
  class: "flex h-full",
  style: {"width":"40%"}
}
const _hoisted_6 = { class: "w-full flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderDropDownMenu = _resolveComponent("HeaderDropDownMenu")!
  const _component_ProblemInfoLabel = _resolveComponent("ProblemInfoLabel")!
  const _component_IconForm = _resolveComponent("IconForm")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.authStatePresenter.isLogin.value)
        ? (_openBlock(), _createBlock(_component_HeaderDropDownMenu, {
            key: 0,
            class: "cursor-pointer",
            menuClickList: [
          () => _ctx.modalStatePresenter.setIsShowSettingsModal(true),
          () => _ctx.modalStatePresenter.setIsShowLoginModal(true)
        ],
            menuIconList: ['settings', 'login'],
            menuTextList: [_ctx.$t('message.settings'), _ctx.$t('message.login')],
            titleIcon: 'no_accounts',
            titleText: _ctx.$t('message.user')
          }, null, 8, ["menuClickList", "menuTextList", "titleText"]))
        : (_ctx.nested.avatarImage.value != undefined || _ctx.nested.avatarImage.value == '')
          ? (_openBlock(), _createBlock(_component_HeaderDropDownMenu, {
              key: 1,
              class: "cursor-pointer",
              menuClickList: [
          () => _ctx.modalStatePresenter.setIsShowDashboardModal(true),
          () => _ctx.modalStatePresenter.setIsShowSettingsModal(true),
          () => _ctx.authStatePresenter.logout()
        ],
              menuIconList: ['dashboard', 'settings', 'logout'],
              menuTextList: [_ctx.$t('message.dashboard'), _ctx.$t('message.settings'), _ctx.$t('message.logout')],
              titleIcon: 'account_circle',
              titleImage: _ctx.nested.avatarImage.value,
              titleText: _ctx.$t('message.user')
            }, null, 8, ["menuClickList", "menuTextList", "titleImage", "titleText"]))
          : (_openBlock(), _createBlock(_component_HeaderDropDownMenu, {
              key: 2,
              class: "cursor-pointer",
              menuClickList: [
          () => _ctx.modalStatePresenter.setIsShowDashboardModal(true),
          () => _ctx.modalStatePresenter.setIsShowSettingsModal(true),
          () => _ctx.authStatePresenter.logout()
        ],
              menuIconList: ['dashboard', 'settings', 'logout'],
              menuTextList: [_ctx.$t('message.dashboard'), _ctx.$t('message.settings'), _ctx.$t('message.logout')],
              titleIcon: 'account_circle',
              titleText: _ctx.$t('message.user')
            }, null, 8, ["menuClickList", "menuTextList", "titleText"])),
      _createVNode(_component_HeaderDropDownMenu, {
        id: "problemSearch",
        class: "cursor-pointer",
        menuClickList: [
          () => _ctx.modalStatePresenter.openProblemSearchModal('COURSE'),
          () => _ctx.modalStatePresenter.openProblemSearchModal('CHALLENGE'),
          () => _ctx.modalStatePresenter.openProblemSearchModal('BOOKMARK'),
          () => _ctx.modalStatePresenter.setIsShowArenaModal(true)
        ],
        menuIconList: ['map', 'inbox', 'bookmark_border', 'flag'],
        menuTextList: [_ctx.$t('message.course'), _ctx.$t('message.challenge'), _ctx.$t('message.bookmark'), _ctx.$t('message.arena')],
        titleIcon: 'assignment',
        titleText: _ctx.$t('message.problems')
      }, null, 8, ["menuClickList", "menuTextList", "titleText"]),
      _createVNode(_component_HeaderDropDownMenu, {
        class: "cursor-pointer",
        menuClickList: [_ctx.clickAOJ1, _ctx.clickAOJ2, () => _ctx.modalStatePresenter.setIsShowFreeSpaceModal(true)],
        menuIconList: ['home', 'account_balance', 'space_dashboard'],
        menuTextList: ['AOJ 1\.0', 'AOJ 2\.0', _ctx.$t('message.freeSpace')],
        titleIcon: 'public',
        titleText: _ctx.$t('message.links')
      }, null, 8, ["menuClickList", "menuTextList", "titleText"]),
      _createVNode(_component_HeaderDropDownMenu, {
        class: "cursor-pointer",
        menuClickList: [_ctx.clickMail, () => _ctx.modalStatePresenter.setIsShowUpdateModal(true), _ctx.clickTour, _ctx.clickHelp],
        menuIconList: ['send', 'update', 'flight', 'info'],
        menuTextList: [_ctx.$t('message.contact'), _ctx.$t('message.update'), _ctx.$t('message.tour'), _ctx.$t('message.tutorial')],
        titleIcon: 'help',
        titleText: _ctx.$t('message.help')
      }, null, 8, ["menuClickList", "menuTextList", "titleText"])
    ]),
    _hoisted_3,
    _createVNode(_component_ProblemInfoLabel),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_HeaderDropDownMenu, {
          class: "mr-4 cursor-pointer",
          itemPY: 'py-1',
          menuClickList: _ctx.languageClickList,
          menuTextList: _ctx.programLanguageList,
          titleText: _ctx.programLanguage
        }, null, 8, ["menuClickList", "menuTextList", "titleText"]),
        _createVNode(_component_IconForm, {
          class: "shadow-md mr-2",
          height: '40px',
          placeholder: _ctx.$t('message.inputProblemId'),
          onEnterForm: _ctx.enterForm
        }, null, 8, ["placeholder", "onEnterForm"])
      ])
    ])
  ]))
}